import type { VChartSpecPipeline } from 'src/types'
import {
  initDonut,
  pieGeometry,
  backgroundColor,
  labelPie,
  tooltip,
  discreteLegend,
  color,
  pieStyle,
  pieHover,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  brush,
  colorPieStyleFill,
  playerPie,
  annotationArea,
  datasetXY,
  isPlayer,
  fontFamilyTheme,
} from '../pipes'

const raceDonut: VChartSpecPipeline = [
  fontFamilyTheme,
  initDonut,
  pieGeometry,
  colorAdapter(color, linearColor),
  backgroundColor,
  isPlayer(playerPie, datasetXY),
  progressive,
  brush,
  labelPie,
  colorPieStyleFill(pieStyle),
  pieHover,
  colorAdapter(discreteLegend, colorLegend),
  tooltip({ titleEncoding: 'color' }),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
]

export const raceDonutSpecPipeline = raceDonut
